module.exports = __webpack_public_path__ + "img/4.276b4cd8.png";